import { Card } from "@/components/ui/card"
import { ArrowsLeftRight, Trophy, Rocket, Globe } from "@phosphor-icons/react"

export function InternationalSection() {
  const pathways = [
    {
      icon: ArrowsLeftRight,
      title: "Exchange Camps",
      description: "India ↔ Nigeria & Africa",
    },
    {
      icon: Trophy,
      title: "International Tournaments",
      description: "Competitive exposure across continents",
    },
    {
      icon: Rocket,
      title: "Scouting & Showcases",
      description: "Direct visibility to clubs and scouts",
    },
    {
      icon: Globe,
      title: "Club & Scholarship Pathways",
      description: "FIFA-aligned placements and opportunities",
    },
  ]

  return (
    <section id="pathways" className="relative py-20 overflow-hidden">
      {/* Image 3: Extends from center - cards have white bg so image can breathe */}
      <div className="absolute inset-0">
        <div className="absolute inset-0 bg-muted" />
        <div className="absolute right-0 top-0 bottom-0 w-2/3 lg:w-1/2">
          <img 
            src="/images/international-pathways.jpg" 
            alt="" 
            className="w-full h-full object-cover object-top"
            aria-hidden="true"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-muted to-transparent" />
        </div>
      </div>
      
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl mb-12">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-gold/20 text-navy text-sm font-medium uppercase tracking-wider mb-4">
            ⚽ Global Football Network
          </div>
          <h2 className="text-4xl sm:text-5xl font-semibold text-navy tracking-tight mb-6">
            International Football Pathways
          </h2>
          <p className="text-xl text-navy/70">
            ZOE Football Academy bridges Asia and Africa to global football ecosystems.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:max-w-4xl">
          {pathways.map((pathway, index) => {
            const Icon = pathway.icon
            return (
              <Card
                key={index}
                className="p-8 bg-ivory border-none hover:shadow-lg transition-shadow duration-300"
              >
                <div className="flex items-start gap-6">
                  <div className="shrink-0">
                    <div className="w-14 h-14 rounded bg-navy/5 flex items-center justify-center">
                      <Icon size={28} weight="regular" className="text-navy" />
                    </div>
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold text-navy mb-2">
                      {pathway.title}
                    </h3>
                    <p className="text-navy/70 leading-relaxed">
                      {pathway.description}
                    </p>
                  </div>
                </div>
              </Card>
            )
          })}
        </div>
      </div>
    </section>
  )
}
